import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { GALLERY_CONSTS, optionsMap } from 'pro-gallery-lib';
import LoveButton from '../loveButton/LoveButton.js';
import ShareStoreIcon from '../svgs/components/share_store';
import Download from '../download/Download';
import { getFinalStyle } from '../sharedBetweenInfoComponents';
export default class Social extends React.Component {
  getSocialShare() {
    const _this$props = this.props,
      options = _this$props.options,
      id = _this$props.id,
      actions = _this$props.actions;
    if (options.allowSocial) {
      const shareButton = /*#__PURE__*/React.createElement("i", {
        className: "share-store"
      }, /*#__PURE__*/React.createElement(ShareStoreIcon, null));
      const socialShareClassName = 'info-member info-element-social-share info-element-social-button';
      if (this.props.viewMode === GALLERY_CONSTS.viewMode.SITE || this.props.viewMode === GALLERY_CONSTS.viewMode.SEO) {
        const slideshowShare = !this.props.shouldUseNewSocialSharePopup && GALLERY_CONSTS.isLayout('SLIDESHOW')(options) ? actions.getShare() : '';
        return /*#__PURE__*/React.createElement("div", {
          className: socialShareClassName,
          "data-hook": "info-element-social-button",
          key: 'item-social-share-' + id,
          onClick: e => actions.toggleShare(e, true)
        }, shareButton, slideshowShare);
      } else {
        return /*#__PURE__*/React.createElement("div", {
          className: socialShareClassName,
          "data-hook": "info-element-social-button",
          key: 'item-social-share-' + id,
          onClick: e => {
            e.stopPropagation();
            e.preventDefault();
          }
        }, shareButton);
      }
    }
    return '';
  }
  getLoveButton() {
    const _this$props2 = this.props,
      options = _this$props2.options,
      isNarrow = _this$props2.isNarrow,
      isSmallItem = _this$props2.isSmallItem;
    return options.loveButton ? /*#__PURE__*/React.createElement(LoveButton, _extends({}, this.props, {
      itemId: this.props.photoId,
      showCounter: options.loveCounter && !isSmallItem && !isNarrow
    })) : null;
  }
  getDownload() {
    const _this$props3 = this.props,
      options = _this$props3.options,
      isDemo = _this$props3.isDemo,
      viewMode = _this$props3.viewMode;
    if (options.allowDownload && !((viewMode === GALLERY_CONSTS.viewMode.SITE || viewMode === GALLERY_CONSTS.viewMode.SEO) && isDemo)) {
      return /*#__PURE__*/React.createElement(Download, this.props);
    }
    return null;
  }
  render() {
    const _this$props4 = this.props,
      isNewInfoElements = _this$props4.isNewInfoElements,
      options = _this$props4.options,
      id = _this$props4.id,
      showShare = _this$props4.showShare,
      isSmallItem = _this$props4.isSmallItem,
      isNarrow = _this$props4.isNarrow,
      isShort = _this$props4.isShort,
      isVerticalContainer = _this$props4.isVerticalContainer;
    const socialShare = this.getSocialShare();
    const loveButton = this.getLoveButton();
    const download = this.getDownload();
    // var shopIcons = this.getShopIcons();
    const isShowArrows = options[optionsMap.layoutParams.thumbnails.enable];
    const isPopulated = options.allowSocial || options.loveButton || options.allowDownload;
    const textPlacementAboveOrBelowOrRightOrLeft = this.props.internalOrExternal === 'external' || GALLERY_CONSTS.hasExternalHorizontalPlacement(options[optionsMap.layoutParams.info.placement]) || GALLERY_CONSTS.hasExternalVerticalPlacement(options[optionsMap.layoutParams.info.placement]);
    const classes = [[showShare && !isNewInfoElements, 'hidden'], [isSmallItem, 'small-item'], [isShort, 'short-item'], [isNarrow, 'narrow-item'], [isVerticalContainer, 'vertical-item'], [isShowArrows, 'with-arrows'], [isPopulated, 'populated-item'], [textPlacementAboveOrBelowOrRightOrLeft, 'text-external-item'], [!isNewInfoElements, 'info-element-social-absolute'], [isNewInfoElements, 'info-element-social-new-info-elements']].filter(x => x[0]).map(x => x[1]).join(' ');

    // Style didnt exist on the div so I need to have the ternary here as well
    const finalStyle = isNewInfoElements == null ? {} : getFinalStyle(this.props);
    // if(this.props.isNewInfoElements){
    //   finalStyle.display = 'flex'
    //   finalStyle.justifyContent = {
    //     'left': 'flex-start',
    //     'center': 'center',
    //     'right': 'flex-end',
    //   }[this.props.horizontalAlignment]
    // }

    return /*#__PURE__*/React.createElement("div", {
      style: finalStyle,
      className: 'info-element-social info-align-' + options.galleryTextAlign + ' ' + classes,
      key: 'item-social-' + id,
      "data-hook": "item-social"
    }, loveButton, download, socialShare);
  }
}
//# sourceMappingURL=Social.js.map